"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = void 0;
/**
 * Utils: Icon map
 * -----------------------------------------------------------------------------
 * Store for SVG icon paths to use in render functions
 * - Use SVGOMG to compress files
 * - Remove any inline fill colours
 * - Add correct BEM class names
 */

var sync = "\n  <svg class=\"icon icon__sync\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\">\n    <path d=\"M48.874997 10.0169a40.000002 40.000002 0 0 0-38.874995 39.99992 40.000002 40.000002 0 0 0 79.999996 0A40.000002 40.000002 0 0 0 48.874997 10.0169zm1.125002 19.99986c5.519995 0 10.497001 2.02499 14.12501 5.62501l5.874988-5.62501v16.00016H54.000211l5.75-6.00003c-2.468009-2.40002-5.873005-4.00009-9.625002-4.00009-6.196005 0-11.344999 4.39996-13.124997 10.00012h-6.625003c1.863998-9.19999 9.961004-16.00016 19.624991-16.00016zM30 54.01692h15.999808l-5.75 5.625c2.467989 2.4 5.872985 3.9999 9.625002 3.9999 6.195985 0 11.344999-4.0249 13.124997-9.6249h6.625003c-1.863999 8.7999-9.961004 15.9999-19.625011 15.9999-5.519994 0-10.497-2.4-14.12499-6l-5.87501 6v-15.9999z\"/>\n  </svg>\n";
var icons = {
  sync: sync
};
exports.icons = icons;